.root {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.horizontal {
    flex-direction: row;
}

.vertical {
    flex-direction: column;
}

.pane {
    flex-grow: 0;
    flex-shrink: 0;
    min-width: 0;
    min-height: 0;
    overflow: auto;
}

.divider {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--tempest-border);
    transition: background-color var(--tempest-duration-fast) var(--tempest-ease-out);
    touch-action: none;
    user-select: none;
}

.divider:hover,
.divider:focus-visible {
    background-color: var(--tempest-primary);
}

.divider:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

.horizontal > .divider {
    width: 6px;
    height: 100%;
    cursor: col-resize;
}

.vertical > .divider {
    width: 100%;
    height: 6px;
    cursor: row-resize;
}

.handle {
    border-radius: var(--tempest-radius-full);
    background-color: var(--tempest-surface);
    opacity: 0.7;
}

.horizontal > .divider .handle {
    width: 2px;
    height: 24px;
}

.vertical > .divider .handle {
    width: 24px;
    height: 2px;
}
